import { useQueryClient } from 'react-query'

import {
  getLogoAndBrandingSettingsCompanyPayload,
  type LogoAndBrandingSettingsFormValues,
} from '@features/invoicingSettings/modules/logoAndBranding'
import { useUpdateInvoicingSettings } from '@features/invoicingSettings/writer'

export const useUpdateLogoAndBrandingSettings = () => {
  const queryClient = useQueryClient()
  const { update, isProcessing } = useUpdateInvoicingSettings()

  const updateLogoAndBrandingSettings = (formData: LogoAndBrandingSettingsFormValues) => {
    return update({
      values: {
        company: getLogoAndBrandingSettingsCompanyPayload(formData, queryClient),
      },
    })
  }

  return { update: updateLogoAndBrandingSettings, isProcessing }
}
